import React, { useEffect } from "react";
import { IS_SERVER } from "@/res/helpers/ServiceHelper";

const useRedirect = (...args) => {
    const hostname = (typeof window !== "undefined") ? window?.location?.hostname ?? "" : "";
    const host = hostname === "localhost" ? "http://sales.localhost:8081" : "https://sales.synega.com";

    useEffect(() => {
        if (IS_SERVER) return;

        let { endpoint, print } = typeof args[0] === "object" ? args[0] : {};

        if (!endpoint) endpoint = args.find(arg => typeof arg === "string");
        if (endpoint && endpoint[0] === "/") endpoint = endpoint.replace("/", "");
        if (!print) print = args.find(arg => typeof arg === "boolean") ?? false;

        if (hostname === "localhost" && print) {
            console.log(`${host}/no-no/${endpoint ?? "not-found"}`)
        } else {
            window.location.replace(`${host}/no-no/${endpoint ?? "not-found"}`);
        }
    }, [])
};

export default useRedirect;
